import React from 'react';

const RetryModal = ({onRetry}) => {
    return (
        <div className="retryInApp-inContainer">
            <p className="text-white font-normal fs16 text-center nowrap">Please Try Again</p>
            <button type="button" className="retryInApp-button mt30 nowrap pointer" onClick={onRetry}>
                <span className="fs14">Try Again</span>
            </button>
        </div>
    );
}

export default RetryModal;
